import { createContext, useContext } from "react";

/**
 * DOM node for the Client Groups detail drawer. MarketingPageShell owns a
 * full-page-height right column (sales `drawerColumn`) and publishes its node
 * here; ClientGroupsList portals its panel into it, so the drawer spans the
 * whole page from the top (beside the header) and shrinks the main column to
 * the left when it opens — matching the Sales tab. Null when no host is
 * mounted (e.g. the list rendered in isolation in a test).
 */
export const ClientGroupsDrawerSlotContext = createContext<HTMLElement | null>(
  null,
);

export const useClientGroupsDrawerSlot = (): HTMLElement | null =>
  useContext(ClientGroupsDrawerSlotContext);
